import { Injectable } from '@angular/core';
import { isFunction } from '@util/utils';
import { merge, Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

type UserDeviceChangeEventType = 'resize' | 'orientation';

export interface UserDeviceChangeEvent {
  type: UserDeviceChangeEventType;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class UserDeviceService {

  private orientationSub = new Subject<any>();
  private resizeSub = new Subject<any>();
  private soListener = false;
  private resizeListener = false;

  /**
   *
   * @param types Event type names
   * @returns
   */
  change(types: string[] = []): Observable<UserDeviceChangeEvent> {
    const res = merge(
      this.resize().pipe(map((ev: any) => {
        return {
          type: "resize",
          data: ev
        } as UserDeviceChangeEvent;
      })),
      this.screenOrientation().pipe(map((ev: any) => {
        return {
          type: "orientation",
          data: ev
        } as UserDeviceChangeEvent;
      }))
    );
    if (types.length) {
      return res.pipe(filter((ev: UserDeviceChangeEvent) => {
        return types.indexOf(ev.type) >= 0;
      }));
    }
    return res;
  }

  resize() {
    if (!this.resizeListener) {
      this.resizeListener = true;
      addEventListener('resize', event => {
        this.resizeSub.next(event);
      });
    }
    return this.resizeSub.asObservable();
  }

  screenOrientation() {
    if (!this.soListener) {
      if (window.screen && window.screen.orientation &&
        isFunction(window.screen.orientation.onchange)) {
        this.soListener = true;
        window.screen.orientation.addEventListener('change', (event: any) => {
          this.orientationSub.next(event);
        })
      } else {
        this.soListener = true;
        addEventListener('orientationchange', event => {
          this.orientationSub.next(event);
        });
      }
    }
    return this.orientationSub.asObservable();
  }
}
